<template>
  <section
    id="about"
    class="section-about">
    <h2 class="numbered-heading">About Me</h2>
    <div class="inner">
      <div class="about-text">
        <div>
          <p>Hello! I'm {{ name }}, a software engineer based in {{ place }}.</p>
          <p>
            I enjoy creating things that live on the internet, whether that be
            websites, applications, or anything in between. My goal is to always
            build products that provide pixel-perfect, performant experiences.
          </p>
          <p>
            Shortly after graduating from <a
              :href="wbutLink"
              target="_blank"
              rel="noopener noreferrer">WBUT university</a>, I
            joined the engineering team at <a
              :href="tcsLink"
              target="_blank"
              rel="noopener noreferrer">TCS</a>, where I
            work on a wide variety of interesting and meaningful projects on a
            daily basis.
          </p>
          <p>Here are a few technologies I've been working with recently:</p>
        </div>
        <ul class="skills-list">
          <li
            v-for="skill in skillList"
            :key="skill.label">
            {{ skill.label }} ({{ skill.exp }})
          </li>
        </ul>
      </div>
      <div class="about-pic">
        <div class="wrapper">
          <div class="image">
            <img
              src="/images/my.JPG"
              alt="My Image"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import EventBus from '@/eventBus'

export default {
  name: 'AboutMe',
  data () {
    return {
      name: 'Soumyadip',
      place: 'Kolkata, IN',
      wbutLink: 'https://makautwb.ac.in/',
      tcsLink: 'https://www.tcs.com/',
      skillList: [
        {
          label: 'JavaScript (ES6+)',
          exp: '6'
        },
        {
          label: 'HTML & (S)CSS',
          exp: '6'
        },
        {
          label: 'React',
          exp: '2.5'
        },
        {
          label: 'Vue',
          exp: '3'
        },
        {
          label: 'Node.js',
          exp: '4'
        },
        {
          label: 'Angular',
          exp: '3'
        }
      ]
    }
  },
  mounted () {
    EventBus.$on('scroll-to-section', (section) => {
      if (section === 'about') {
        this.scrollToElement2(section)
      }
    })
  },
  methods: {
    scrollToElement (section) {
      const el = this.$el.querySelector('#about')
      console.log(el)
      if (el) {
        console.log('found')
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    scrollToElement2 (section) {
      var elem = this.$el
      elem.scrollTop = elem.clientHeight
    }
  }
}
</script>

<style scoped>
</style>
